import React, {Component} from 'react';
import {withAlert} from 'react-alert';
import {postRequest} from "../routes/Routes";
import '../assets/css/Home.css';

class ContactUs extends Component {
    constructor(props) {
        super(props);
        this.state = {loading: false};
    }

    render() {
        return (
            <div className="container">
                <div className="login-component">
                    <h1 className="heading">volkslanka</h1>
                    <h3 className="form-heading">Get in touch with us</h3>
                    <form onSubmit={this.contactUsFunction}>
                        <div className="form-group">
                            <input className="form-control" placeholder='First Name*' id="firstName" required/>
                        </div>
                        <div className="form-group">
                            <input className="form-control" placeholder='Last Name*' id="lastName" required/>
                        </div>
                        <div className="form-group">
                            <input type="email" className="form-control" placeholder='Email Address*' id="email"
                                   required/>
                        </div>
                        <div className="form-group">
                            <input type="tel" className="form-control" placeholder='Phone Number (0771234567)*'
                                   id="phone" pattern="[0-9]{10}" required/>
                        </div>
                        <div className="form-group">
                            <textarea className="form-control custom-textarea" placeholder='Message*' id="message"
                                      required/>
                        </div>
                        <button className="btn blue-button login-button" disabled={this.state.loading}>
                            {this.state.loading ?
                                <span className="spinner-grow spinner-grow-sm ml-1" role="status" aria-hidden="true"/>
                                : null
                            }
                            Send Message
                        </button>
                    </form>
                    <div className="d-flex bd-highlight w-100 contact-us-details">
                        <div className="p-2 flex-fill bd-highlight">
                            <h4>Email</h4>
                            <div>hello@volkslanka.com</div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            <h4>Phone</h4>
                            <div>+94 77 638 3868</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    contactUsFunction = async (event) => {
        event.preventDefault();
        this.setState({loading: true});
        let values = {
            firstName: event.target.firstName.value,
            lastName: event.target.lastName.value,
            email: event.target.email.value,
            phone: event.target.phone.value,
            message: event.target.message.value,
            endpoint: '/api/contact-us/create'
        };
        postRequest(values).then(response => {
            if (response.status === 200) {
                if (response.data.error) {
                    this.props.alert.error(response.data.message);
                } else {
                    this.props.alert.success("Thank you for contacting us. We'll get in touch with you soon");
                }
            } else {
                this.props.alert.error(response.data.message);
            }
            this.setState({loading: false});
        });
    }
}

export default withAlert()(ContactUs);